import { render, staticRenderFns } from "./featureCard.vue?vue&type=template&id=dfa76b6c&scoped=true"
import script from "./featureCard.vue?vue&type=script&lang=js"
export * from "./featureCard.vue?vue&type=script&lang=js"
import style0 from "./featureCard.vue?vue&type=style&index=0&id=dfa76b6c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfa76b6c",
  null
  
)

export default component.exports